// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-Global":"Global_cost-saving-Global__6Uaah"};